import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KeyboardFocusService {
  private activeKeyboardId: string | null = null;

  setActiveKeyboard(id: string): void {
    this.activeKeyboardId = id;
  }

  getActiveKeyboard(): string | null {
    return this.activeKeyboardId;
  }

  clearActiveKeyboard(): void {
    this.activeKeyboardId = null;
  }
}
